import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-doc',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './doc.component.html',
  styleUrl: './doc.component.scss'
})
export class DocComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/doc-edit/';
  override addLink = '/dashboard/doc-create';

  clientList: Record<string, string> = {};
  clientListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('doc');
    // this.crudService.orderBy = 'createdAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Order',
        field: 'order',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'En',
        field: 'label_en',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Es',
        field: 'label_es',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
